import { matchPath } from "react-router-dom";
import { datadogRum } from "./datadogRum";
import { isDatadogRumEnabled } from "./config";
import { redactSensitiveSegments } from "./scrubbing";

// Manual SPA view tracking for react-router v5 (the React plugin's router
// integration only supports v6/v7 and requires React 18). On each navigation we
// resolve the current pathname to its declared route PATTERN (e.g.
// `/fund-profile/:entityID`) so views group cleanly and leak no identifiers.

const specificity = (pattern: string): number => {
  const segments = pattern.split("/").filter(Boolean);
  const staticSegments = segments.filter((segment) => !segment.startsWith(":")).length;

  return segments.length * 100 + staticSegments;
};

export const matchRouteName = (pathname: string, patterns: string[]): string => {
  const orderedPatterns = [...patterns].sort((a, b) => specificity(b) - specificity(a));

  const matched = orderedPatterns.find((pattern) => matchPath(pathname, { path: pattern, exact: true }));

  return matched ?? (redactSensitiveSegments(pathname) as string) ?? pathname;
};

export const startDatadogView = (pathname: string, patterns: string[]): void => {
  if (!isDatadogRumEnabled()) return;

  datadogRum.startView({ name: matchRouteName(pathname, patterns) });
};
